const flow = (request, api_config) => {
  const prefix = "Flow";

  const GetBarcodeOrderFlows = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetBarcodeOrderFlows`,
      method: "post",
      data: data,
    });
    return result;
  };

  return {
    GetBarcodeOrderFlows,
  };
};

export default flow;
